import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { UserService } from "src/app/core/services/user.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { GenericLabelValue } from "src/app/shared/models/DTO/GenericLabelValue.dto";
import { LicenseFeature } from "src/app/shared/models/license-feature.model";
import { License } from "src/app/shared/models/license.model";

@Component({
	selector: "app-kitchen-device-color-profile-setup",
	templateUrl: "./kitchen-device-color-profile-setup.component.html",
	styleUrls: ["../../../../../commandcenter.scss"],
})
export class KitchenDeviceColorProfileSetupComponent implements OnInit {
	@Input() kitchenDevice: License;
	@Output() kitchenDeviceChange = new EventEmitter<License>();

	@Input() features: LicenseFeature;
	@Output() featuresChange = new EventEmitter<LicenseFeature>();

	@Input() changesToSave: boolean;
	@Output() changesToSaveChange = new EventEmitter<boolean>();

	copyFromViewSourceLicenseKey: string;

	fontSizeOptions: GenericLabelValue[];

	constructor(public app: AppService, private focuslink: FocuslinkService, public venueService: OOVenueService, public userService: UserService) {}

	ngOnInit(): void {
		this.fontSizeOptions = [
			{
				label: "X-Small",
				value: 10,
			},
			{
				label: "Small",
				value: 15,
			},
			{
				label: "Medium",
				value: 20,
			},
			{
				label: "Large",
				value: 30,
			},
			{
				label: "X-Large",
				value: 40,
			},
		];
	}

	copyColorProfileFromView(event) {
		const sourceLicense = event.value;
		const sourceFeatures = this.venueService.licensesKitchenDevice.value.find((i) => i.key === sourceLicense).features;
		Object.keys(sourceFeatures).forEach((key) => {
			if (key.includes("kitchen")) {
				this.features[key] = sourceFeatures[key];
			}
		});
		this.changesToSaveChange.emit(true);
	}
}
